export function pxToVw(px: number, designWidth = 375, decimals = 6): string {
  if (typeof px !== 'number' || Number.isNaN(px)) {
    return '0vw'
  }
  const val = (px / designWidth) * 100
  return `${Number(val.toFixed(decimals))}vw`
}
